import React from "react"
import ReactGA from "react-ga";

export default function Demo() {
  const requestDemoClick = () => {
    ReactGA.event({
      category: `Einvoicing Aus_Request demo_Green button`,
      action: `Einvoicing Aus_Request demo_Green button clicked`
    });
  }
  return (
      <section className="demo bg-gray-30 flex items-center">
        <div className="container sm:flex sm:flex-row justify-between items-center">
          <div className="left flex items-center ml-8">
            <h3 className="text-2xl font-bold text-left">
              Perhaps you need a personalised demo?
              Get in touch with us today!
            </h3>
          </div>
          <div className="right text-left sm:mt-0 mt-8 ml-0 sm:ml-20 mr-0 sm:mr-20 leading-6 text-gray-20">
            <a
                onClick={requestDemoClick}
                href="https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus"
                className="bg-mind rounded leading-7 rounded  focus:outline-none text-white px-10 py-3 capitalize create-btn"
            >
              Request a Demo
            </a>
          </div>
        </div>
      </section>
  )
}
